// pages/Services.js
import React from 'react';
import ServiceCard from '../Components/ServiceCard';
import ServiceRequestForm from '../Components/ServiceRequestForm';
import services from '../data/services.json';

function Services() {
  const { header, services: serviceList } = services;
  return (
    <div className="services-page">
      <section className="page-header">
        <div className="container">
          <h1>{header.title}</h1>
          <p>{header.subtitle}</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {serviceList.map((service, index) => (
            <ServiceCard key={index} service={service} />
          ))}
        </div>
      </section>

      {/* Service Request Form */}
      <section className="section" style={{ background: 'var(--light-gray)' }}>
        <div className="container">
          <h2 className="section-title">Request a Service</h2>
          <ServiceRequestForm />
        </div>
      </section>
    </div>
  );
}

export default Services;